import { ExtendCurrency } from 'src/enums'
import { toDollars } from 'src/utils/currency.utils'

export interface CreateVirtualCardDataResponse {
  // TODO: fill this out properly
  displayName: string
  recipient?: string
  balanceCents: number
  currency: ExtendCurrency
}

export class CreateVirtualCardDataModel {
  public displayName: string
  public recipient?: string
  public balanceCents: number
  public currency: ExtendCurrency

  public constructor(data: CreateVirtualCardDataResponse) {
    this.displayName = data.displayName
    this.recipient = data.recipient
    this.balanceCents = data.balanceCents
    this.currency = data.currency
  }

  public get balance(): number {
    return toDollars(this.balanceCents)
  }

  public get truncatedDisplayName(): string {
    return this.displayName.length > 45
      ? `${this.displayName.slice(0, 44)}...`
      : this.displayName
  }
}

export interface VirtualCardPushTaskErrorResponse {
  headers: unknown
  body: {
    error?: string
    details?: Array<{ error: string }>
  }
  statusCode: string
  statusCodeValue: number
}

export class VirtualCardPushTaskErrorModel {
  public headers: unknown
  public body: {
    error?: string
    details?: Array<{ error: string }>
  }
  public statusCode: string
  public statusCodeValue: number

  public constructor(data: VirtualCardPushTaskErrorResponse) {
    this.headers = data.headers
    this.body = data.body
    this.statusCode = data.statusCode
    this.statusCodeValue = data.statusCodeValue
  }
}

export enum VirtualCardPushTaskStatus {
  Initiated = 'Initiated',
  Completed = 'Completed',
  Failed = 'Failed',
}

export interface VirtualCardPushTaskListResponse {
  taskId: string
  status: VirtualCardPushTaskStatus
  record: CreateVirtualCardDataResponse | undefined
  virtualCardId?: string
  uploadId: string
  errors?: VirtualCardPushTaskErrorResponse
}

export class VirtualCardPushTaskListModel {
  public taskId: string
  public status: VirtualCardPushTaskStatus
  public record?: CreateVirtualCardDataModel
  public virtualCardId?: string
  public uploadId: string
  public errors?: VirtualCardPushTaskErrorModel

  public constructor(data: VirtualCardPushTaskListResponse) {
    this.taskId = data.taskId
    this.status = data.status
    this.record =
      data.record !== undefined
        ? new CreateVirtualCardDataModel(data.record)
        : undefined
    this.virtualCardId = data.virtualCardId
    this.uploadId = data.uploadId
    this.errors =
      data.errors !== undefined
        ? new VirtualCardPushTaskErrorModel(data.errors)
        : undefined
  }
}

export enum JobStatus {
  Running = 'Running',
  Completed = 'Completed',
  Failed = 'Failed',
}
